import i18n from 'i18next';
import dataConstant from '../../constants/dataConstants';


const toSentenceCase = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const toLower = (str) => str?.toLowerCase() || "";

export const nameValidator = (labelKey) => (value) => {
  const rawLabel = i18n.t(labelKey);

  if (!value) {
    return `${toSentenceCase(rawLabel)} ${toSentenceCase(i18n.t("Required"))}`;
  }

  if (!dataConstant.NoSpecialCharacterRegex.test(value)) {
    return `${toSentenceCase(i18n.t("SpecialCharacter"))} ${toLower(rawLabel)}`;
  }

  if (value.trim() === "") {
    return `${toSentenceCase(i18n.t("Whitespace"))} ${toLower(rawLabel)}`;
  }

  return true;
};

export const whiteSpaceValidator = (labelKey) => (value) => {
  const rawLabel = i18n.t(labelKey);
  if (!value) {
    return `${toSentenceCase(rawLabel)} ${toSentenceCase(i18n.t("Required"))}`;
  }
  if (value.trim() === "") {
    return `${toSentenceCase(i18n.t("Whitespace"))} ${toLower(rawLabel)}`;
  }
  return true;
};

export const phoneNumberValidator = (labelKey) => (value) => {
  const rawLabel = i18n.t(labelKey);
   if (!value || value.trim() === "") {
    return true;
  }
  if (!dataConstant.NoAlphabetCharacterRegex.test(value)) {
    return `${i18n.t("Please enter valid")} ${rawLabel?.toLowerCase()}`;
  }
  return true;
};

export const zipCodeValidator = (labelKey) => (value) => {
  const rawLabel = i18n.t(labelKey);
  if (!value) return true;
  if (value.trim() === "") {
    return `${i18n.t("Whitespace")} ${rawLabel?.toLowerCase()}`;
  }
  return true;
};